import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Tables } from "database.types";
import { numericToNumber } from "@/utils/numericToNumber";

interface Props {
  variant: Tables<"variants"> & { condition: Tables<"conditions"> };
}

export function CardDetailsModalStats({ variant }: Props) {
  const avgPrice = variant.avgPrice;
  const minPrice7D = variant.minPrice7D;
  const maxPrice7D = variant.maxPrice7D;
  const priceChange7D = variant.priceChange7D;
  const maxPriceAllTime = variant.maxPriceAllTime;
  const minPriceAllTime = variant.minPriceAllTime;

  return (
    <Card>
      <CardHeader>
        <h3 className="text-lg font-semibold">Price Statistics</h3>
      </CardHeader>
      <CardContent className="space-y-3">
        {avgPrice !== undefined && avgPrice !== null && (
          <div className="flex justify-between">
            <span className="text-muted-foreground">Average Price:</span>
            <span className="font-medium">{`$${numericToNumber(variant.avgPrice).toFixed(2)}`}</span>
          </div>
        )}
        {minPrice7D !== undefined && minPrice7D !== null && (
          <div className="flex justify-between">
            <span className="text-muted-foreground">7-Day Low:</span>
            <span className="font-medium">{`$${numericToNumber(variant.minPrice7D).toFixed(2)}`}</span>
          </div>
        )}
        {maxPrice7D !== undefined && maxPrice7D !== null && (
          <div className="flex justify-between">
            <span className="text-muted-foreground">7-Day High:</span>
            <span className="font-medium">{`$${numericToNumber(variant.maxPrice7D).toFixed(2)}`}</span>
          </div>
        )}
        {priceChange7D !== undefined && variant.priceChange7D !== null && (
          <div className="flex justify-between">
            <span className="text-muted-foreground">7-Day Change:</span>
            <span
              className={`font-medium ${
                numericToNumber(priceChange7D) >= 0
                  ? "text-green-600"
                  : "text-red-600"
              }`}
            >
              {numericToNumber(priceChange7D) > 0 ? "+" : ""}
              {numericToNumber(priceChange7D).toFixed(2)}%
            </span>
          </div>
        )}
        {maxPriceAllTime !== undefined && variant.maxPriceAllTime !== null && (
          <div className="flex justify-between">
            <span className="text-muted-foreground">All-Time High:</span>
            <span className="font-medium">{`$${numericToNumber(maxPriceAllTime).toFixed(2)}`}</span>
          </div>
        )}
        {minPriceAllTime !== undefined && minPriceAllTime !== null && (
          <div className="flex justify-between">
            <span className="text-muted-foreground">All-Time Low:</span>
            <span className="font-medium">{`$${numericToNumber(variant.minPriceAllTime).toFixed(2)}`}</span>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
